import React from 'react'
import { observer } from 'mobx-react-lite'

import { StoreMultiProductSwitch } from './StoreMultiProductSwitch'

import { useLogic, useStore } from '../hooks/storeHook'

export const WbMultiProductSwitch =
  observer(() => {
    const {user} = useStore()
    const {setWbMultiProducts} = useLogic()

    if (!user) {
      throw new Error('Not authorized')
    }

    return <StoreMultiProductSwitch
      allowMultiProducts={user.allowMultiWbProducts}
      setMultiProducts={setWbMultiProducts}
    />
  })